<template>
	<section class="other_page_banner receive_main banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							{{ $t('new_ui.personal_receive_page.section_banner.title.one') }}
						</h5>
						<h2>
							{{
								$t('new_ui.personal_receive_page.section_banner.main_title.one')
							}}
						</h2>
						<p>
							{{
								$t('new_ui.personal_receive_page.section_banner.paragraph.one')
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="maximize_rewards_sec received_left">
		<div class="container">
			<div class="row">
				<div class="col-sm-4 receive_desk">
					<div class="maximize_rewards_lt">
						<img :src="img.image2" alt="Logo" />
					</div>
				</div>
				<div class="col-sm-4 receive_mob">
					<div class="maximize_rewards_lt">
						<img :src="img.image7" alt="Logo" />
					</div>
				</div>
				<div class="col-sm-8">
					<div class="maximize_rewards_rt">
						<span>{{
							$t('new_ui.personal_receive_page.maximize_rewards_sec.label')
						}}</span>
						<div class="maximize_rewards_txt">
							<h4>
								{{
									$t(
										'new_ui.personal_receive_page.maximize_rewards_sec.title.one',
									)
								}}
								<span>{{
									$t(
										'new_ui.personal_receive_page.maximize_rewards_sec.title.two',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_receive_page.maximize_rewards_sec.title.three',
									)
								}}
							</h4>
							<p>
								{{
									$t(
										'new_ui.personal_receive_page.maximize_rewards_sec.paragraph.one',
									)
								}}
							</p>

							<div class="starting_to_btn pay_world">
								<a href="/auth/register">{{
									$t(
										'new_ui.personal_receive_page.maximize_rewards_sec.cta_buttons.one',
									)
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="credit_system">
		<div class="container">
			<div class="row">
				<div class="col-sm-6 border_dash">
					<div class="creditcard_system_inn credit_system_rt">
						<img class="d-block d-md-none" :src="img.image4" alt="" />
						<span>{{
							$t('new_ui.personal_receive_page.credit_system_sec.label')
						}}</span>
						<div class="creditcard_system_txt">
							<h4>
								<span>{{
									$t('new_ui.personal_receive_page.credit_system_sec.title.one')
								}}</span
								>{{
									$t('new_ui.personal_receive_page.credit_system_sec.title.two')
								}}
								<br />{{
									$t(
										'new_ui.personal_receive_page.credit_system_sec.title.three',
									)
								}}
							</h4>
							<p>
								{{
									$t(
										'new_ui.personal_receive_page.credit_system_sec.paragraph.one',
									)
								}}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.personal_receive_page.credit_system_sec.cta_buttons',
									)
								}}</a>
							</div>
							<img class="d-none d-md-block" :src="img.image4" alt="" />
						</div>
					</div>
				</div>
				<div class="col-sm-6 border_dash">
					<div class="creditcard_system_inn credit_system_rt">
						<img :src="img.image3" alt="" />
						<span>{{
							$t('new_ui.personal_receive_page.credit_system_right_sec.label')
						}}</span>
						<div class="creditcard_system_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.personal_receive_page.credit_system_right_sec.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_receive_page.credit_system_right_sec.title.two',
									)
								}}
								<span>{{
									$t(
										'new_ui.personal_receive_page.credit_system_right_sec.title.three',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_receive_page.credit_system_right_sec.title.four',
									)
								}}
								<br />{{
									$t(
										'new_ui.personal_receive_page.credit_system_right_sec.title.five',
									)
								}}
							</h4>
							<p>
								{{
									$t(
										'new_ui.personal_receive_page.credit_system_right_sec.paragraph.one',
									)
								}}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.personal_receive_page.credit_system_right_sec.cta_buttons',
									)
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="question_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-4 question_mob">
					<div class="question_lt">
						<img :src="img.image8" alt="" />
					</div>
				</div>
				<div class="col-sm-8">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{
								$t('new_ui.personal_receive_page.question_sec.label')
							}}</span>
							<div class="payment_world_txt">
								<h4>
									{{
										$t('new_ui.personal_receive_page.question_sec.title.one')
									}}
									<span>{{
										$t('new_ui.personal_receive_page.question_sec.title.two')
									}}</span>
								</h4>
								<p>
									{{
										$t(
											'new_ui.personal_receive_page.question_sec.paragraph.one',
										)
									}}
								</p>
								<div class="starting_to_btn pay_world">
									<a href="/auth/register">{{
										$t(
											'new_ui.personal_receive_page.question_sec.cta_buttons.one',
										)
									}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-4 question_desk">
					<div class="question_lt">
						<img :src="img.image5" alt="" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="received_request_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-3">
					<div class="received_request_lt">
						<img :src="img.image6" alt="" />
					</div>
				</div>
				<div class="col-sm-9">
					<div class="received_request_rt">
						<span>{{
							$t('new_ui.personal_receive_page.received_request_sec.label')
						}}</span>
						<div class="received_request_rt_txt">
							<h4>
								{{
									$t(
										'new_ui.personal_receive_page.received_request_sec.title.one',
									)
								}}
								<span>{{
									$t(
										'new_ui.personal_receive_page.received_request_sec.title.two',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_receive_page.received_request_sec.title.three',
									)
								}}
							</h4>
							<p>
								{{
									$t(
										'new_ui.personal_receive_page.received_request_sec.paragraph.one',
									)
								}}
							</p>
							<p>
								{{
									$t(
										'new_ui.personal_receive_page.received_request_sec.paragraph.two',
									)
								}}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.personal_receive_page.received_request_sec.cta_buttons.one',
									)
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.personal_receive_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.personal_receive_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_receive_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.personal_receive_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.personal_receive_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.personal_receive_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.personal_receive_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import receiveban from '@/assets/images/sub/receive_ban.png';
import r1 from '@/assets/images/sub/r1.png';
import r2 from '@/assets/images/sub/r2.png';
import r3 from '@/assets/images/sub/r3.png';
import r4 from '@/assets/images/sub/r6.png';
import rmob from '@/assets/images/sub/rmob.png';
import r5 from '@/assets/images/sub/recv_req_mob.png';
import r6 from '@/assets/images/sub/recv_mob_dia.png';

export default {
	data: () => {
		return {
			img: {
				image1: receiveban,
				image2: rmob,
				image3: r1,
				image4: r2,
				image5: r3,
				image6: r4,
				image7: r5,
				image8: r6,
			},
		};
	},
};
</script>
